import { useEffect } from 'react';
import styled from 'styled-components';
import LifeStyleContent from '../components/LifeStyleContent';
import lifestyle from '../data/lifestyle.json';
import images from '../img';

function LifeStyle({
    resultNum,
    setPage
}) {
    const keys = Object.keys(lifestyle.key);
    useEffect(() => {
        if (!keys.includes(resultNum)) {
            window.alert("결과가 없습니다.");
            window.history.back();
        }
    }, []);
    if (!keys.includes(resultNum)) {
        return null;
    }
    const currentResultKey = lifestyle.key[resultNum].name;
    const currentResult = lifestyle.data[currentResultKey];
    currentResult.name = currentResultKey;
    const lifeStyleContent = currentResult.content || [
        {
            picture: [
                null,
                null
            ],
            name: "title",
            tag: ["tag1", "tag2"]
        },
        {
            picture: [
                null,
                null
            ],
            name: "title",
            tag: ["tag1", "tag2"]
        },
        {
            picture: [
                null,
                null
            ],
            name: "title",
            tag: ["tag1", "tag2"]
        }
    ];
    return (<LifeStyleStyledWrapper>
        <div className='lifestyle-head'>
            <div className='logo-wrap'>
                <img className='logo' src={images["life_logo-pc_2.png"]} />
                <img className='logo-mobile' src={images["life_logo-m_2.png"]} />
            </div>
            <button className='lifestyle-btn1-pc'
                onClick={() => {
                    setPage("result");
                }}>
                <img src={images["btn_result-pc2.png"]} />
            </button>
            <div className='lifestyle-title-wrap'>
                <div className='lifestyle-title'>
                    {currentResult?.name}
                </div>
                <div className='lifestyle-description' dangerouslySetInnerHTML={{
                    __html: currentResult?.description || ""
                }}></div>
            </div>
        </div>
        <div className='lifestyle-body'>
            {lifeStyleContent.map((x, i) => <LifeStyleContent key={i} name={x.name} tag={x.tag} picture={x.picture} />)}
        </div>
        <div className='lifestyle-foot'>
            <button className='lifestyle-btn1-mobile'
                onClick={() => {
                    setPage("result");
                }}>
                <img src={images["btn_result-m2.png"]} />
            </button>
        </div>
    </LifeStyleStyledWrapper>);
}

export default LifeStyle;

const LifeStyleStyledWrapper = styled.div`
    .lifestyle-body{
        padding:0 21.8rem;
        display: flex;
        .lifestyle-content:not(:last-of-type){
            .body{
                padding-right:4.1rem;
                border-right: 1px solid #d1d1d1;
            }
            margin-right:4.1rem;
        }
    }
    .lifestyle-foot{
        .lifestyle-btn1-mobile{
            display: none;
        }
    }
    .lifestyle-head{
        height: 28.0rem;
        flex-direction: column;
        padding: 8.0rem 13.0rem 5.6rem;
        background-color: #edeeef;
        display: flex;
        box-sizing: border-box;
        justify-content: space-between;
        align-items: center;
        margin-bottom:4rem;
        .lifestyle-btn1-pc{
            border:0;
            background-color: transparent;
            position:absolute;
            top:9.2rem;
            right:10.3rem;
            cursor: pointer;
            img{
                height: 11.4rem;
            }
        }
        .logo-wrap{
            display: flex;
            width: 100%;
            .logo-mobile{
                display: none;
            }
            .logo{
                height: 2.6rem;
            }
        }
        .lifestyle-title-wrap{
            display: flex;
            justify-content: flex-start;
            width: 100%;
            padding:0 9rem;
            box-sizing: border-box;
            .lifestyle-title{
                height:6rem;
                font-size: 6rem;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 0.8;
                letter-spacing: -0.06rem;
                padding-right: 5rem;
                margin-right: 5rem;
                border-right:solid 2px #7b0d10;
                text-align: center;
                color: #000;
            }
            .lifestyle-description{
                position: relative;
                top:-0.4rem;
                font-size: 2rem;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.6;
                letter-spacing: normal;
                text-align: left;
                color: #413e3d;
            }
        }
    }
    @media screen and (max-width:990px){
        .lifestyle-foot{
            padding-bottom:4rem;
            .lifestyle-btn1-mobile{
                display: block;
                height:4.5rem;
                padding:0;
                margin:0;
                border:0;
                background-color: transparent;
                margin:auto;
                cursor: pointer;
                img{
                    height: 100%;
                }
            }
        }
        .lifestyle-body{
            padding:0 2rem;
            display: flex;
            flex-direction: column;
            .lifestyle-content{
                margin-bottom:4rem;
                .picture{
                    width:100%;
                    height:22.1rem;
                }
                .name{
                    line-height: 1;
                }
                .tag{
                    li{
                        line-height: 1.3;
                    }
                }
            }
            .lifestyle-content:not(:last-of-type){
                .body{
                    padding-right:unset;
                    border-right:unset;
                }
                margin-right:unset;
            }
        }
        .lifestyle-head{
            padding:5.5rem 2rem 3.8rem;
            height:unset;
            .lifestyle-btn1-pc{
                display: none;
            }
            .logo-wrap{
                .logo{
                    display: none;
                }
                .logo-mobile{
                    display: block;
                    margin:auto;
                    height:10.4rem;
                }
            }
            .lifestyle-title-wrap{
                display: flex;
                justify-content: flex-start;
                width: 100%;
                padding:unset;
                height:unset;
                flex-direction: column;
                .lifestyle-title{
                    margin:1.7rem 0;
                    font-size:3.6rem;
                    padding-right: unset;
                    margin-right:unset;
                    height:unset;
                    line-height: 1;
                    border:0;
                }
                .lifestyle-description{
                    margin-top:0;
                    font-size: 1.5rem;
                    font-weight: normal;
                    font-stretch: normal;
                    word-break: keep-all;
                    font-style: normal;
                    line-height: 1.47;
                    letter-spacing: -0.15px;
                    text-align: center;
                    color: #494949;
                }
            }
        }
    }
`;